import { ThunkDispatch } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

/* eslint @typescript-eslint/no-explicit-any: 0 */
export const useThunkDispatch = () => useDispatch<ThunkDispatch<any, any, any>>();
